import { ModalState } from '../../types/modal'

export const getModalState = (state: { modal: ModalState }): any => state.modal
